/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyAutocompleteFilter
 */
export interface AgencyAutocompleteFilter {
    /**
     * 
     * @type {boolean}
     * @memberof AgencyAutocompleteFilter
     */
    strictBrandAndMarket?: boolean;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof AgencyAutocompleteFilter
     */
    brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAutocompleteFilter
     */
    agencyGroup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyAutocompleteFilter
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AgencyAutocompleteFilter
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyAutocompleteFilter
     */
    term?: string | null;
}

export function AgencyAutocompleteFilterFromJSON(json: any): AgencyAutocompleteFilter {
    return AgencyAutocompleteFilterFromJSONTyped(json, false);
}

export function AgencyAutocompleteFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyAutocompleteFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'strictBrandAndMarket': !exists(json, 'strictBrandAndMarket') ? undefined : json['strictBrandAndMarket'],
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'agencyGroup': !exists(json, 'agencyGroup') ? undefined : json['agencyGroup'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
    };
}

export function AgencyAutocompleteFilterToJSON(value?: AgencyAutocompleteFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'strictBrandAndMarket': value.strictBrandAndMarket,
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
        'agencyGroup': value.agencyGroup,
        'showNonEffective': value.showNonEffective,
        'limit': value.limit,
        'term': value.term,
    };
}


